import { LinearProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/b2b/Modal";
import SideBar from "../../components/b2b/SideBar";
import { PlusIcon } from "@heroicons/react/solid";
import VehicleTypeItem from "../../components/b2b/VehicleType/VehicleTypeItem";
import Header from "../../components/landingPage/Header";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faCarRear, faCarSide } from "@fortawesome/free-solid-svg-icons";
import {
  AccordionSummary,
  Accordion,
  AccordionDetails,
  Typography,
  Container,
  Skeleton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LoadingIcon from "../../components/loading/LoadingIcon";

const VehicleTypes = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { allVehicles, updating, categories, creating, vehicelsLoading } =
    useSelector((state) => state.vehicle);
  const [newVehicleAddModal, setnewVehicleAddModal] = useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [vehicleImageUpdate, setvehicleImageUpdate] = useState(undefined);
  const [vehicleCategory, setVehicleCategory] = useState();
  const [vehicleDetails, setvehicleDetails] = useState({
    categoryType: "",
    description: "",
    personCount: "",
    luggageCount: "",
    status: "",
    vehicleName: "",
  });
  const [categoryOpen, setcategoryOpen] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    dispatch({
      type: "SHOW_VEHICLE_CATEGORY",
      payload: {
        token: token,
      },
    });
  }, []);

  const formData = new FormData();

  const addVehicleHandler = () => {
    if (
      vehicleDetails.vehicleName === "" ||
      vehicleDetails.description === "" ||
      vehicleDetails.personCount === "" ||
      vehicleDetails.luggageCount === "" ||
      vehicleDetails.status === ""
    ) {
      toast.warn("All fields are required!");
    } else {
      if (vehicleImageUpdate === undefined) {
        toast.warn("Car image must be upload!");
      } else {
        vehicleImageUpdate?.name &&
          formData.append("vehicleImage", vehicleImageUpdate);
        formData.append("categoryType", vehicleDetails.categoryType);
        formData.append("vehicleName", vehicleDetails.vehicleName);
        formData.append("description", vehicleDetails.description);
        formData.append("passengerCount", parseInt(vehicleDetails.personCount));
        formData.append("luggageCount", parseInt(vehicleDetails.luggageCount));

        vehicleDetails.status &&
          formData.append("status", vehicleDetails.status);

        //

        dispatch({
          type: "ADD_VEHICLE",
          payload: {
            body: formData,
          },
        });
        //
        setvehicleDetails({
          vehicleType: "",
          description: "",
          personCount: "",
          luggageCount: "",
          status: "",
        });
        setvehicleImageUpdate(undefined);
        setnewVehicleAddModal(false);
      }
    }
  };

  console.log(categories, "categories");

  return (
    <div className="h-screen w-screen fixed ">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-full">
          {newVehicleAddModal && (
            <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50">
              <Modal
                heading="Add Vehicle"
                cancelOnClick={() => {
                  setnewVehicleAddModal(false);
                  setvehicleDetails({
                    vehicleType: "",
                    description: "",
                    personCount: "",
                    luggageCount: "",
                    status: "",
                  });
                  setvehicleImageUpdate(undefined);
                }}
                addOnClick={addVehicleHandler}
                addButtonLabel="Save"
                isVehicleAdd={true}
                vehicleImageInput={(e) => {
                  setvehicleImageUpdate(e.target.files[0]);
                }}
                categoryType={vehicleDetails?.categoryType}
                vehicleImage={vehicleImageUpdate}
                vehicleTypeValue={vehicleDetails?.vehicleName}
                vehicleTypeInput={(e) => {
                  setvehicleDetails({
                    ...vehicleDetails,
                    vehicleName: e.target.value,
                  });
                }}
                vehicleDescriptionValue={vehicleDetails?.description}
                vehicleDescription={(e) => {
                  setvehicleDetails({
                    ...vehicleDetails,
                    description: e.target.value,
                  });
                }}
                noOfPassengerValue={vehicleDetails.personCount}
                noOfPassenger={(e) => {
                  setvehicleDetails({
                    ...vehicleDetails,
                    personCount: e.target.value,
                  });
                }}
                noOfLuggageValue={vehicleDetails.luggageCount}
                noOfLuggage={(e) => {
                  setvehicleDetails({
                    ...vehicleDetails,
                    luggageCount: e.target.value,
                  });
                }}
                vehicleStatusValue={vehicleDetails.status}
                vehicleStatusChange={(e) => {
                  setvehicleDetails({
                    ...vehicleDetails,
                    status: e.target.value,
                  });
                }}
              />
            </div>
          )}
          <div className="flex justify-between mx-3">
            <div className="pt-2 flex space-x-1 items-center">
              <div>
                <div className="text-sm text-gray-800 font-body">
                  Add new vehicle category
                </div>
                <input
                  type="text"
                  placeholder="Category"
                  className="textField font-body"
                  value={vehicleCategory}
                  onChange={(e) => setVehicleCategory(e.target.value)}
                />
              </div>
              <div
                onClick={() => {
                  dispatch({
                    type: "ADD_VEHICLE_CATEGORY",
                    payload: {
                      token,
                      body: {
                        name: vehicleCategory,
                      },
                    },
                  });
                  setVehicleCategory("");
                }}
                className="flex px-3 space-x-1 py-1.5 bg-secondary rounded-md text-white font-semibold hover:bg-red-600 cursor-pointer"
              >
                <FontAwesomeIcon icon={faAdd} />
                <div className="text-xs font-body">Add</div>
              </div>
              <div>{creating && <LoadingIcon />}</div>
            </div>
            <div className="flex items-center">
              {/* <div className="text-xl text-primary font-semibold px-5 py-5">
                Vehicle Types
              </div> */}
              {updating && (
                <div className="w-52 py-2">
                  <div className="text-sm italic font-body">Updating...</div>
                  <LinearProgress />
                </div>
              )}
            </div>
          </div>
          <div className="overflow-y-auto scrollbar h-[83vh] mt-8">
            {!vehicelsLoading ? (
              categories.map((category) => {
                return (
                  <>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        className=""
                      >
                        <Container className="flex items-center space-x-2 px-3.5 md:px-0">
                          <Typography className=" font-body text-sm">
                            {category?.name}
                          </Typography>
                        </Container>
                        <Container className="flex items-center space-x-2 px-3.5 md:px-0">
                          <div
                            onClick={() => {
                              setnewVehicleAddModal(true);
                              setvehicleDetails({
                                ...vehicleDetails,
                                categoryType: category?.name,
                              });
                            }}
                            className="flex px-2 py-2 sm:space-x-2 text-sm items-center tracking-wider rounded-sm cursor-pointer border border-secondary hover:shadow-lg  text-secondary my-3 sm:mr-6"
                          >
                            <FontAwesomeIcon
                              icon={faCarSide}
                              className="w-3 hidden sm:block"
                            />
                            <div className="font-semibold font-body">
                              Add New Vehicle
                            </div>
                          </div>
                        </Container>
                      </AccordionSummary>
                      <AccordionDetails className="bg-slate-100">
                        <div className="w-[83vw] overflow-x-scroll scrollbar ">
                          <div className="md:flex 2xl:mx-10 lg:mx-10 md:mx-16 sm:mx-5 space-x-6">
                            {category?.vehicles?.map((vehicle) => (
                              <>
                                <VehicleTypeItem
                                  key={vehicle._id}
                                  id={vehicle._id}
                                  description={vehicle?.description}
                                  status={vehicle?.status}
                                  vehicleType={vehicle?.vehicleName}
                                  categoryType={vehicle?.categoryType}
                                  vehicleImage={
                                    vehicle?.vehicleImage?.secure_url
                                  }
                                  personCount={vehicle?.passengerCount}
                                  luggageCount={vehicle?.luggageCount}
                                />
                              </>
                            ))}
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </>
                );
              })
            ) : (
              <>
                <div className="px-10">
                  <Skeleton animation="wave" height={100} />
                  <Skeleton animation="wave" height={100} />
                  <Skeleton animation="wave" height={100} />
                  <Skeleton animation="wave" height={100} />
                  <Skeleton animation="wave" height={100} />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(VehicleTypes);
